import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center gap-4 p-4"
}
const _hoisted_2 = { class: "relative w-full max-w-xl aspect-[3/4]" }
const _hoisted_3 = { class: "absolute inset-0 flex items-center justify-center pointer-events-none" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex flex-col items-center gap-4 p-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex items-center gap-4" }

import { ref, onMounted, onUnmounted } from 'vue'
import Button from 'primevue/button'
import moment from 'moment'

const widthPx = 354
const heightPx = 472


export default /*@__PURE__*/_defineComponent({
  __name: 'takeCamera',
  emits: ["usePhoto", "hideDialog"],
  setup(__props, { emit: __emit }) {

const videoRef = ref<HTMLVideoElement | null>(null)
const canvasRef = ref<HTMLCanvasElement | null>(null)
const photo = ref<string | null>(null)
const photoForm = ref(null) as any

// Ukuran 4x6 cm dalam pixel (300 DPI) ubah jadi  472 x 709 px
// Ukuran 3x4 cm dalam pixel @300 DPI
let stream: MediaStream | null = null

const emit = __emit

const setupCamera = async () => {
  photo.value = null
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: 'environtment', // 'user' untuk kamera depan, 'environment' untuk kamera belakang
      },
    })
    if (videoRef.value) {
      videoRef.value.srcObject = stream
    }
  } catch (err) {
    console.error('Gagal mengakses kamera:', err)
  }
}

const useCurrentPhoto = () => {
  emit('usePhoto', photoForm.value)
  emit('hideDialog')
}

onMounted(async () => {
  setupCamera()
})

onUnmounted(() => {
  // eslint-disable-next-line no-unused-expressions
  stream?.getTracks().forEach((track) => track.stop())
})

function takePhoto() {
  if (!videoRef.value || !canvasRef.value) return

  const ctx = canvasRef.value.getContext('2d')
  if (!ctx) return

  const vw = videoRef.value.videoWidth
  const vh = videoRef.value.videoHeight

  const targetAspect = widthPx / heightPx
  const videoAspect = vw / vh

  let sx = 0; let sy = 0; let sw = vw; let sh = vh

  if (videoAspect > targetAspect) {
    sw = vh * targetAspect
    sx = (vw - sw) / 2
  } else {
    sh = vw / targetAspect
    sy = (vh - sh) / 2
  }

  ctx.drawImage(videoRef.value, sx, sy, sw, sh, 0, 0, widthPx, heightPx)
  photo.value = canvasRef.value.toDataURL('image/png')
  const fileTemp = ref(null) as any
  const blobTemp = ref(null) as any
  canvasRef.value.toBlob((blob) => {
    console.log('blob', blob)
    if (!blob) {
      console.log('error blob')
      // eslint-disable-next-line no-useless-return
      return
    }
    blobTemp.value = blob

    fileTemp.value = new File([blob], `foto-${Date.now()}.png`, {
      type: 'image/png',
      lastModified: Date.now()
    })

    photoForm.value = {
      blob: blobTemp.value,
      file: fileTemp.value
    }
  }, 'image/png')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!photo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("video", {
              ref_key: "videoRef",
              ref: videoRef,
              autoplay: "",
              playsinline: "",
              class: "w-full h-full object-cover rounded shadow"
            }, null, 512),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "border-2 border-red-500 rounded-sm",
                style: _normalizeStyle({
              width: '56%', // Responsif berdasarkan video container
              aspectRatio: `${widthPx} / ${heightPx}`
            })
              }, null, 4)
            ])
          ]),
          _createVNode(_unref(Button), {
            class: "btn-primary mr-1",
            onClick: takePhoto
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Ambil Foto")
            ])),
            _: 1,
            __: [0]
          }),
          _createElementVNode("canvas", {
            ref_key: "canvasRef",
            ref: canvasRef,
            width: widthPx,
            height: heightPx,
            class: "hidden"
          }, null, 512)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (photo.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: photo.value,
                  alt: "Foto 3x4",
                  class: "w-[120px] rounded shadow border border-gray-300"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (photo.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: photo.value,
                  download: "foto-3x4.png",
                  class: "text-blue-600 underline mt-2"
                }, " Unduh Foto ", 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(Button), {
                class: "btn-primary mr-1",
                onClick: setupCamera
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Ambil Foto Lagi")
                ])),
                _: 1,
                __: [1]
              }),
              _createVNode(_unref(Button), {
                class: "btn-primary mr-1",
                onClick: useCurrentPhoto
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Gunakan Foto Ini")
                ])),
                _: 1,
                __: [2]
              })
            ])
          ])
        ]))
  ]))
}
}

})